/**
 * 会滚动变化的金额。
 *
 * 收完款余额从 RM 1,400 跳到 RM 500，直接换掉数字的话，
 * 老板得回想一下「刚才是多少来着」才能确认这笔收对了。
 * 让它滚过去，变化本身就是确认 —— 这是这个动画唯一的理由，不是为了好看。
 *
 * 只在【值真的变了】时动。首次渲染直接显示，页面加载时一堆数字乱滚是噪音。
 */

import { useEffect, useRef, useState } from 'react'
import { rm } from '../lib/format'

const DURATION = 420

export function AnimatedAmount({
  value,
  className,
}: {
  value: number | null
  className?: string
}) {
  const [shown, setShown] = useState(value)
  const prev = useRef(value)
  const raf = useRef(0)

  useEffect(() => {
    if (value === null || prev.current === null || value === prev.current) {
      prev.current = value
      setShown(value)
      return
    }

    // 尊重系统的「减少动态效果」设置
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      prev.current = value
      setShown(value)
      return
    }

    const from = prev.current
    const to = value
    const start = performance.now()
    prev.current = value

    const tick = (now: number) => {
      const t = Math.min((now - start) / DURATION, 1)
      // easeOutCubic：起步快、收尾稳，读起来像「落定」而不是「刹车」
      const eased = 1 - Math.pow(1 - t, 3)
      setShown(Math.round(from + (to - from) * eased))
      if (t < 1) raf.current = requestAnimationFrame(tick)
    }
    raf.current = requestAnimationFrame(tick)
    return () => cancelAnimationFrame(raf.current)
  }, [value])

  return <span className={className}>{rm(shown)}</span>
}
